import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Button } from 'components/styled/button'
import { Flex } from 'components/styled/containers/flex'
import { Body, Label } from 'components/styled/typography'
import { InputStyle } from 'components/form-components/styled-text-input'
import { mapLanguageToComponentProps } from 'i18n'
import { actions } from 'react-redux-form'
import { getValueAndFieldByModel } from 'utils/form'
import validator from 'validator'
import FormErrors from 'components/form-components/form-errors'
import { ConfirmDelete } from 'components/confirm-delete'

const propTypes = {
  i18n: PropTypes.shape({
    linkListInput: PropTypes.shape({}),
    jobAdApplication: PropTypes.shape({}),
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  model: PropTypes.string.isRequired,
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
  isRequired: PropTypes.bool,
  readOnly: PropTypes.bool,
  placeholder: PropTypes.string,
  limit: PropTypes.number,
}

const defaultProps = {
  isRequired: false,
  readOnly: false,
  placeholder: undefined,
  limit: 5,
}

const LinkInput = styled.div`
  display: flex;
  align-items: center;
`

const AddButton = styled(Button)`
  margin-left: -${({ theme }) => theme.space.s40};
`

const StyledList = styled.ul`
  background-color: ${({ theme }) => theme.color.grey07};
  border: none;
  list-style: none;
  padding: 0;
  margin: 0;
`

const ListItem = styled.li`
  padding: 0 ${({ theme }) => theme.space.s12};
  line-height: ${({ theme }) => theme.space.s40};
  display: flex;
  word-break: break-all;
  justify-content: space-between;

  .remove-link {
    color: ${({ theme }) => theme.color.error110};
    cursor: pointer;
    white-space: nowrap;

    &:hover {
      color: ${({ theme }) => theme.color.error110};
    }
  }

  &:nth-child(even) {
    background-color: ${({ theme }) => theme.color.grey05};
  }
`

const StyledInput = styled.input`
  ${InputStyle};
`
export class LinkListInput extends Component {
  constructor() {
    super()
    this.onKeyPress = this.onKeyPress.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
  }

  componentDidMount() {
    // If we don't have value when this is mount set error or user can
    // submit form without value
    const { dispatch, isRequired, model, value } = this.props
    if (isRequired && value.length === 0) {
      dispatch(actions.setErrors(model, { isRequired: true }))
    }
  }

  componentDidUpdate(prevProps) {
    const { dispatch, isRequired, model, value } = this.props
    // Set isRequred error if no value
    if (isRequired && prevProps.value.length > 0 && value.length === 0) {
      dispatch(actions.setErrors(model, { isRequired: true }))
    }
  }

  onKeyPress(event) {
    if (event.charCode === 13) {
      this.addField()
      event.preventDefault()
    }
  }

  onChange() {
    const { model, dispatch, isRequired, value } = this.props
    if (isRequired && this.linkInput.value === '' && value.length === 0) {
      dispatch(actions.setErrors(model, { isRequired: true }))
    } else if (this.linkInput.value === '') {
      dispatch(actions.setErrors(model, false))
    }
  }

  onBlur() {
    if (this.linkInput.value !== '') {
      this.addField()
    }
  }

  removeField(index) {
    const { dispatch, model } = this.props
    dispatch(actions.remove(model, index))
  }

  addField() {
    const { dispatch, model, i18n } = this.props
    const { linkInput } = this
    const validtorOptions = {
      protocols: ['http', 'https'],
      require_protocol: true,
    }

    if (!linkInput.value.startsWith('http')) {
      linkInput.value = `http://${linkInput.value}`
    }

    if (validator.isURL(linkInput.value, validtorOptions)) {
      dispatch(actions.push(model, linkInput.value))
      dispatch(actions.setErrors(model, false))
      linkInput.value = ''
    } else {
      dispatch(actions.setTouched(model))
      dispatch(actions.setErrors(model, i18n.linkListInput.invalidUrl))
    }
  }

  render() {
    const { model, readOnly, placeholder, value, limit, i18n, isRequired } =
      this.props
    const { length } = value

    // show links length in counter if links length is higher than limit
    const counterLimit = length > limit ? length : limit
    return (
      <>
        <Label color="grey90">{`${i18n.jobAdApplication.legendLinks}${
          isRequired ? '*' : ''
        }`}</Label>
        <StyledList>
          {value.map((link, index) => (
            <ListItem key={link}>
              {link}
              <ConfirmDelete
                color="error110"
                size="small"
                showDeleteText
                onConfirm={() => this.removeField(index)}
              />
            </ListItem>
          ))}
        </StyledList>
        {length < limit && (
          <LinkInput>
            <StyledInput
              type="url"
              name={model}
              ref={linkInput => {
                this.linkInput = linkInput
              }}
              disabled={readOnly}
              placeholder={placeholder}
              onKeyPress={this.onKeyPress}
              onChange={this.onChange}
              onBlur={this.onBlur}
            />
            <AddButton
              size="small"
              onClick={() => this.addField(model)}
              variant="secondary"
              icon="add"
            />
          </LinkInput>
        )}
        <Flex justifyContent="space-between" alignItems="center">
          <FormErrors model={model} show={{ touched: true }} />
          <Body textAlign="right">{`${length}/${counterLimit}`}</Body>
        </Flex>
      </>
    )
  }
}

LinkListInput.propTypes = propTypes
LinkListInput.defaultProps = defaultProps

export default connect(
  mapLanguageToComponentProps((state, { model }) => {
    const { value = {} } = getValueAndFieldByModel(state, model)
    return { value }
  })
)(LinkListInput)
